<template>
  <div class="materiais-padronizados">
    <div class="row">
      <div class="col-xs-12">
        <button type="button" class="btn btn-primary btn-voltar" @click="$router.back()">
          <font-awesome-icon :icon="'arrow-left'"/>
          Voltar
        </button>
        <h1 class="page-header">{{ label }} Material Padronizado</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <form role="form" @submit.prevent="save" id="tag_form">
          <fieldset>
            <!--Select-->
            <div class="col-xs-12 col-sm-4">
              <div
                :class="[
                  'form-group',
                  { 'has-error': errors.has('grupo_codigo') }
                ]"
              >
                <label class="control-label custom-font">Grupo</label>
                <div class="custom-select">
                  <select
                    ref="grupo_codigo"
                    class="form-control select-selected"
                    name="grupo_codigo"
                    v-model="model.grupo_codigo"
                    v-validate="'required'"
                    @change="loadSubgrupos"
                  >
                    <option
                      v-for="p in grupos"
                      :key="p.codigo"
                      :value="p.codigo"
                    >
                      {{ p.nome }}
                    </option>
                  </select>
                </div>
                <small
                  v-if="errors.has('grupo_codigo')"
                  data-bv-validator="notempty"
                  data-bv-validator-for="grupo_codigo"
                  class="help-block"
                  style=""
                  >Preenchimento obrigatório!</small
                >
              </div>
            </div>

            <!-- Select -->
            <div class="col-xs-12 col-sm-4">
              <div
                :class="[
                  'form-group',
                  { 'has-error': errors.has('subgrupo_codigo') }
                ]"
              >
                <label class="control-label custom-font">Subgrupo</label>
                <div class="custom-select">
                  <select
                    ref="subgrupo_codigo"
                    class="form-control select-selected"
                    name="subgrupo_codigo"
                    v-model="model.subgrupo_codigo"
                    v-validate="'required'"
                  >
                    <option
                      v-for="p in subgrupos"
                      :key="p.codigo"
                      :value="p.codigo"
                    >
                      {{ p.nome }}
                    </option>
                  </select>
                </div>
                <small
                  v-if="errors.has('subgrupo_codigo')"
                  data-bv-validator="notempty"
                  data-bv-validator-for="subgrupo_codigo"
                  class="help-block"
                  style=""
                  >Preenchimento obrigatório!</small
                >
              </div>
            </div>

            <!-- Select -->
            <div class="col-xs-12 col-sm-4">
              <div
                :class="[
                  'form-group',
                  { 'has-error': errors.has('medida_codigo') }
                ]"
              >
                <label class="control-label custom-font">Medida</label>
                <div class="custom-select">
                  <select
                    ref="medida_codigo"
                    class="form-control select-selected"
                    name="medida_codigo"
                    v-model="model.medida_codigo"
                    v-validate="'required'"
                  >
                    <option
                      v-for="p in medidas"
                      :key="p.codigo"
                      :value="p.codigo"
                    >
                      {{ p.nome }}
                    </option>
                  </select>
                </div>
                <small
                  v-if="errors.has('medida_codigo')"
                  data-bv-validator="notempty"
                  data-bv-validator-for="medida_codigo"
                  class="help-block"
                  style=""
                  >Preenchimento obrigatório!</small
                >
              </div>
            </div>

            <!-- Text input-->
            <div class="col-xs-12 col-sm-4">
              <div
                :class="[
                  'form-group',
                  { 'has-error': errors.has('referencia') }
                ]"
              >
                <label
                  :class="[
                    'control-label',
                    'custom-font',
                    { 'is-danger': errors.has('referencia') }
                  ]"
                  >Referência</label
                >
                <div class="inputGroupContainer">
                  <div class="input-group">
                    <span
                      :class="[
                        'input-group-addon',
                        { 'is-danger': errors.has('referencia') }
                      ]"
                    >
                      <font-awesome-icon
                        :icon="'tags'"
                        :class="[{ 'is-danger': errors.has('referencia') }]"
                      ></font-awesome-icon>
                    </span>
                    <input
                      ref="referencia"
                      v-model="model.referencia"
                      name="referencia"
                      v-validate="'required'"
                      maxlength="13"
                      :class="[
                        'form-control',
                        { 'is-danger': errors.has('referencia') }
                      ]"
                      placeholder="Referência"
                      type="text"
                    />
                    <div
                      :class="[
                        'input-group-addon custom-input-group-addon-count',
                        { 'is-danger': errors.has('referencia') }
                      ]"
                      v-text="13 - model.referencia.length"
                    ></div>
                  </div>
                  <small
                    v-if="errors.has('referencia')"
                    data-bv-validator="notEmpty"
                    data-bv-validator-for="referencia"
                    class="help-block"
                    style=""
                  >
                    <font-awesome-icon :icon="'exclamation-triangle'" />
                    {{ errors.first('referencia') }}
                  </small>
                </div>
              </div>
            </div>

            <!-- Text input-->
            <div class="col-xs-12 col-sm-8">
              <div :class="['form-group', { 'has-error': errors.has('nome') }]">
                <label
                  :class="[
                    'control-label',
                    'custom-font',
                    { 'is-danger': errors.has('nome') }
                  ]"
                  >Nome</label
                >
                <div class="inputGroupContainer">
                  <div class="input-group">
                    <span
                      :class="[
                        'input-group-addon',
                        { 'is-danger': errors.has('nome') }
                      ]"
                    >
                      <font-awesome-icon
                        :icon="'id-card'"
                        :class="[{ 'is-danger': errors.has('nome') }]"
                      />
                    </span>
                    <input
                      ref="nome"
                      v-model="model.nome"
                      name="nome"
                      v-validate="'required'"
                      maxlength="100"
                      :class="[
                        'form-control',
                        'custom-input',
                        { 'is-danger': errors.has('nome') }
                      ]"
                      placeholder="Nome"
                      type="text"
                    />
                    <div
                      :class="[
                        'input-group-addon custom-input-group-addon-count',
                        { 'is-danger': errors.has('nome') }
                      ]"
                      v-text="100 - model.nome.length"
                    ></div>
                  </div>
                  <small
                    v-if="errors.has('nome')"
                    data-bv-validator="notEmpty"
                    data-bv-validator-for="nome"
                    class="help-block"
                    style=""
                  >
                    <font-awesome-icon :icon="'exclamation-triangle'" />
                    {{ errors.first('nome') }}
                  </small>
                </div>
              </div>
            </div>

            <!-- Textarea input-->
            <div class="col-xs-12">
              <div
                :class="[
                  'form-group',
                  { 'has-error': errors.has('descricao') }
                ]"
              >
                <label
                  :class="[
                    'control-label',
                    'custom-font',
                    { 'is-danger': errors.has('descricao') }
                  ]"
                  >Descrição</label
                >
                <div class="inputGroupContainer">
                  <div class="input-group">
                    <span
                      :class="[
                        'input-group-addon',
                        { 'is-danger': errors.has('descricao') }
                      ]"
                    >
                      <font-awesome-icon
                        :icon="'edit'"
                        :class="[{ 'is-danger': errors.has('descricao') }]"
                      ></font-awesome-icon>
                    </span>
                    <textarea
                      ref="descricao"
                      v-model="model.descricao"
                      name="descricao"
                      v-validate="'required'"
                      maxlength="1000"
                      :class="[
                        'form-control',
                        { 'is-danger': errors.has('descricao') }
                      ]"
                      placeholder="Informe a descrição do material..."
                      rows="10"
                    />
                    <div
                      :class="[
                        'input-group-addon custom-input-group-addon-count',
                        { 'is-danger': errors.has('descricao') }
                      ]"
                      v-text="1000 - model.descricao.length"
                    ></div>
                  </div>
                  <small
                    v-if="errors.has('descricao')"
                    data-bv-validator="notEmpty"
                    data-bv-validator-for="descricao"
                    class="help-block"
                    style=""
                  >
                    <font-awesome-icon :icon="'exclamation-triangle'" />
                    {{ errors.first('descricao') }}
                  </small>
                </div>
              </div>
            </div>

            <!-- Button -->
            <div class="col-xs-12">
              <div class="form-group">
                <div class="pull-right">
                  <button
                    class="btn btn-default"
                    :disabled="carregando"
                  >
                    <font-awesome-icon
                      v-if="carregando"
                      :icon="'spinner'"
                      spin
                    />
                    <font-awesome-icon v-else :icon="'save'" />
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-select {
  border: 1px solid;
  border-radius: 4px;
  border-color: #00615c;
}

.select-selected {
  background-color: #eeeeee;
  color: #00615c;
}

.custom-input-group-addon-count {
  color: #00615c;
}

.fa-tags {
  color: #00615c;
}

.fa-id-card {
  color: #00615c;
}

.fa-edit {
  color: #00615c;
}

.custom-font.is-danger {
  color: #990000;
}

.custom-input-group-addon-count.is-danger {
  color: #990000;
}

.fa-tags.is-danger {
  color: #990000;
}

.fa-id-card.is-danger {
  color: #990000;
}

.fa-edit.is-danger {
  color: #990000;
}

.btn-voltar {
  margin-top: 20px;
}
</style>

<script>
import { request } from '@/request'

export default {
  name: 'materiais-padronizados-new-save',
  data() {
    return {
      label: 'Adicionar',
      model: {
        referencia: '',
        nome: '',
        descricao: '',
        medida_codigo: '',
        subgrupo_codigo: '',
        grupo_codigo: ''
      },
      carregando: false,
      medidas: [],
      subgrupos: [],
      grupos: []
    }
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  mounted() {
    const { id } = this.$router.history.current.params
    if (id) {
      this.label = 'Editar'
      this.loadModel(id)
    } else {
      this.loadMedidas()
      this.loadGrupos()
    }
  },
  methods: {
    async loadGrupos() {
      const respGrupo = await this.fetchGrupos()
      const {
        data: { grupo_codigo: grupo }
      } = respGrupo
      const respSubgrupo = await this.fetchSubgrupos(grupo)

      this.grupos = respGrupo.data
      this.subgrupos = respSubgrupo.data

      this.model.grupo_codigo = this.grupos[0].codigo
      this.model.subgrupo_codigo = this.subgrupos[0].codigo
    },
    fetchGrupos() {
      return request.get('materiais/listar-grupos')
    },
    async loadSubgrupos() {
      const { grupo_codigo: grupo } = this.model
      const response = await this.fetchSubgrupos(grupo)
      this.subgrupos = response.data
      this.model.subgrupo_codigo = this.subgrupos[0].codigo
    },
    fetchSubgrupos(grupo) {
      return request.get('materiais/listar-subgrupos', { params: { grupo } })
    },
    async loadMedidas() {
      const response = await this.fetchMedidas()
      this.medidas = response.data
      if (!this.model.medida_codigo)
        this.model.medida_codigo = this.medidas[0].codigo
    },
    fetchMedidas() {
      return request.get('materiais/lista-medidas')
    },
    async loadModel(id) {
      const response = await request.get(`material/${id}`)
      const responseMedidas = await this.fetchMedidas()
      const responseGrupos = await this.fetchGrupos()
      const {
        data: { codigo: grupo }
      } = responseGrupos
      const responseSubgrupos = await this.fetchSubgrupos(grupo)

      this.medidas = responseMedidas.data
      this.grupos = responseGrupos.data
      this.subgrupos = responseSubgrupos.data

      this.model = response.data
    },
    toogleLoading() {
      this.carregando = !this.carregando
    },
    saveSuccess(result) {
      this.$toastr.s('Este item foi salvo com sucesso.')
      this.$router.push({ name: 'user_material' })
    },
    saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.')
      this.toogleLoading()
    },
    save() {
      this.toogleLoading()
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$refs[this.$validator.errors.items[0].field].focus()
          this.$toastr.e(this.$validator.errors.items[0].msg)
          return
        }
      })

      // update
      if (this.model.codigo) {
        request
          .put(`material/${this.model.codigo}`, this.model)
          .then(this.saveSuccess)
          .catch(this.saveFail)
      } else {
        // add
        request
          .post('material', this.model)
          .then(this.saveSuccess)
          .catch(this.saveFail)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/materiais-padronizados/Save.vue